// extracted by mini-css-extract-plugin
export default {"container":"GameFieldOffCanvasCustomMove_container__3JCXq","positionSelect":"GameFieldOffCanvasCustomMove_positionSelect__2-w9t"};